import { render, staticRenderFns } from "./UiConfirm.vue?vue&type=template&id=2ff71c0c"
import script from "./UiConfirm.vue?vue&type=script&lang=js"
export * from "./UiConfirm.vue?vue&type=script&lang=js"
import style0 from "./UiConfirm.vue?vue&type=style&index=0&id=2ff71c0c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports